import { Box } from "@caspeco/casper-ui-library.components.box";
import {
	ThemeColorVariable,
	ThemeRadiusVariable,
	ThemeSpaceVariable,
} from "@caspeco/casper-ui-library.base-ui.theme";
import { Stack } from "@caspeco/casper-ui-library.components.stack";
import { Skeleton } from "@caspeco/casper-ui-library.components.skeleton";
import { AspectRatioWrapper } from "components/aspect-ratio-wrapper/AspectRatioWrapper";
import { AspectRatio } from "types/ui";

function SkeltonArticleDetailsFooter() {
	return (
		<Box display="flex" flexDirection="row" alignItems="center" p={ThemeSpaceVariable.Medium}>
			<Box display="flex" flexDirection="row">
				<Skeleton w="44px" h="44px" borderRadius={ThemeRadiusVariable.XLarge} mr={ThemeSpaceVariable.Large} />
				<Skeleton w="44px" h="44px" borderRadius={ThemeRadiusVariable.XLarge} />
			</Box>
			<Skeleton w="100%" ml={ThemeSpaceVariable.Medium} borderRadius={ThemeRadiusVariable.XLarge} h="54px" />
		</Box>
	);
}

export function SkeletonArticleDetails() {
	return (
		<span data-testid="loading-indicator">
			<Box
				display="flex"
				flexDirection="column"
				borderRadius={ThemeRadiusVariable.Large}
				bg={ThemeColorVariable.Background}
				w="100%"
			>
				<AspectRatioWrapper $aspectratio={AspectRatio.SixteenByNine}>
					<Skeleton w="100%" h="auto" />
				</AspectRatioWrapper>
				<Box display="flex" flexDirection="column" justifyContent="space-between" flexGrow="1">
					<Box p={ThemeSpaceVariable.Medium}>
						<Skeleton h="2rem" w="60%" mb={ThemeSpaceVariable.Medium} />
						<Stack spacing={ThemeSpaceVariable.Medium}>
							<Skeleton h="1rem" />
							<Skeleton h="1rem" />
						</Stack>
						<Stack spacing={ThemeSpaceVariable.Medium} my={ThemeSpaceVariable.Medium}>
							<Skeleton h="2rem" w="30%" mb={ThemeSpaceVariable.Medium} />
							<Skeleton h="3rem" mb={ThemeSpaceVariable.Medium} />
							<Skeleton h="3rem" />
							<Skeleton h="1rem" w="40%" />
						</Stack>
						<Stack display={[null, "none"]} spacing={ThemeSpaceVariable.Medium}>
							<Skeleton h="3rem" />
							<Skeleton h="3rem" />
						</Stack>
					</Box>
					<SkeltonArticleDetailsFooter />
				</Box>
			</Box>
		</span>
	);
}
